// reducer.js

import { createSlice } from "@reduxjs/toolkit";
import initialState from "./state";
import { fetchCourses } from "./actionCreator";

export const courseSlice = createSlice({
  name: "course",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchCourses.pending, (state) => {
      state.isLoading = true;
      state.error = null;
    });
    builder.addCase(fetchCourses.fulfilled, (state, action) => {
      console.log("action.payload", action.payload.payload.stats.activeBatches);
      state.isLoading = false;
      state.data = action.payload.payload.data;
      state.error = null;
      state.totalCourses = action.payload.payload.stats.totalCourses;
      state.activeBatches = action.payload.payload.stats.activeBatches;
      state.enrolledStudent = action.payload.payload.stats.enrolledStudent;
    });
    builder.addCase(fetchCourses.rejected, (state, action) => {
      state.isLoading = false;
      state.data = [];
      state.error = action.error.message;
    });
  },
});

export default courseSlice.reducer;
